<template>
  <div>
    <ContentWrapper :setBackground="{type: 'bgcolor', value: '#eaeff2'}">
      <div class="w-11/12 max-w-1366 m-auto">
        <div class="bg-white border-t-16 border-green p-2 xl:p-8">
          <h2 class="font-bold text-2xl xl:text-3xl mb-6 mt-6 xl:mt-8 text-center">回顧2020年永續城市大調查</h2>
          <div class="flex flex-wrap flex-col-reverse md:flex-row">
            <div class="w-11/12 md:w-1/2 mx-auto">
              <p class="mb-4">「SDGs(Ｓustainable Development Ｇoals)已經成為國際間共通語言。」經常參與國際交流的行政院數位政委唐鳳發現這兩年新趨勢：象徵「永續發展」的指標---SDGs，是熱門關鍵字，更是城市新顯學！</p>
              <p>原本是「國家」級努力目標，卻在這兩年在城市間興起，紐約市首先響應，成為第一個回應聯合國永續發展目標的地方政府，他們自動發布紐約城市的永續政策作為。而你知道，去年所公布全球20大永續城市其中台灣就佔了三個，分別為：新北市、台北與桃園。以積極度來看，台灣跟世界城市相比，絕對排得上前段班。</p>
            </div>
            <div class="w-full md:w-1/2">
              <a href="#" target="blank">
                <img
                  class="w-4/5 md:w-full mb-6 md:mb-0 mx-auto md:pl-6 xl:pl-10"
                  src="../assets/images/sustainable_city.png"
                  alt="《2020永續城市》台灣首次六都大調查"
                  title="《2020永續城市》台灣首次六都大調查"
                />
              </a>
            </div>
          </div>
          <ul class="flex justify-center mt-8 mb-4 xl:mt-12 xl:mb-8">
            <li
              @click="setActive(0)"
              :class="active === 0 ?
                'bg-green mx-2 px-4 py-2 cursor-pointer text-white font-bold border border-green' :
                'bg-white mx-2 px-4 py-2 cursor-pointer border border-green text-green font-bold'"
            >綜合評比</li>
            <li
              @click="setActive(1)"
              :class="active === 1 ?
                'bg-green mx-2 px-4 py-2 cursor-pointer text-white font-bold' :
                'bg-white mx-2 px-4 py-2 cursor-pointer border border-green text-green font-bold'"
            >特殊獎項</li>
          </ul>
          <div v-show="active === 0">
            <ul class="flex flex-wrap justify-between">
              <li class="w-4/5 md:w-3/10 m-auto">
                <figure class="relative">
                  <img class="w-full" src="../assets/images/city_newtaipei.png" alt="">
                  <figcaption
                    class="absolute px-6 py-2 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-white bg-black-op70"
                  >第一名</figcaption>
                </figure>
                <p class="text-xl text-center mt-1 mb-3 md:mt-2 md:mb-0">新北市</p>
              </li>
              <li class="w-4/5 md:w-3/10 m-auto">
                <figure class="relative">
                  <img class="w-full" src="../assets/images/city_taoyuan.png" alt="">
                  <figcaption
                    class="absolute px-6 py-2 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-white bg-black-op70"
                  >第二名</figcaption>
                </figure>
                <p class="text-xl text-center mt-1 mb-3 md:mt-2 md:mb-0">桃園市</p>
              </li>
              <li class="w-4/5 md:w-3/10 m-auto">
                <figure class="relative">
                  <img class="w-full" src="../assets/images/city_taipei.png" alt="">
                  <figcaption
                    class="absolute px-6 py-2 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-white bg-black-op70"
                  >第三名</figcaption>
                </figure>
                <p class="text-xl text-center mt-1 mb-3 md:mt-2 md:mb-0">台北市</p>
              </li>
            </ul>
          </div>
          <div v-show="active === 1">
            <ul class="flex flex-wrap justify-between">
              <li class="w-4/5 md:w-3/10 m-auto">
                <figure class="relative">
                  <img class="w-full" src="../assets/images/city_newtaipei3.png" alt="">
                  <figcaption
                    class="absolute px-6 py-2 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-white bg-black-op70"
                  >環境力</figcaption>
                </figure>
                <p class="text-xl text-center mt-1 mb-3 md:mt-2 md:mb-0">新北市</p>
              </li>
              <li class="w-4/5 md:w-3/10 m-auto">
                <figure class="relative">
                  <img class="w-full" src="../assets/images/city_taoyuan2.png" alt="">
                  <figcaption
                    class="absolute px-6 py-2 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-white bg-black-op70"
                  >經濟力</figcaption>
                </figure>
                <p class="text-xl text-center mt-1 mb-3 md:mt-2 md:mb-0">桃園市</p>
              </li>
              <li class="w-4/5 md:w-3/10 m-auto">
                <figure class="relative">
                  <img class="w-full" src="../assets/images/city_newtaipei2.png" alt="">
                  <figcaption
                    class="absolute px-6 py-2 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-white bg-black-op70"
                  >社會力</figcaption>
                </figure>
                <p class="text-xl text-center mt-1 mb-3 md:mt-2 md:mb-0">新北市</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </ContentWrapper>
  </div>
</template>

<script>
import ContentWrapper from './models/ContentWrapper'

export default {
  name: 'Review',
  components: {
    ContentWrapper
  },
  data() {
    return {
      active: 0
    }
  },
  methods: {
    setActive(target) {
      this.active = target;
    }
  }
}
</script>
